export default "__VITE_ASSET__BDfZ5POM__"